import Vue from 'vue';

export function createEvents () {
  return new Vue({
    data () {
      return {
        AUTH_REDIRECT_ERROR: 'AuthRedirectError',
        REQUEST_JOBSUBMIT_SUCCESS: 'JobSubmitSuccess',
        REQUEST_JOBSUBMIT_ERROR: 'JobSubmitError',
        REQUEST_JOBSUBMIT_SCAM: 'JobSubmitScam',
        REQUEST_VALIDATION_ERROR: 'JobSubmitValidationError',
        REQUEST_NO_PROS_AVAILABLE: 'NoProsAvailable',
        REQUEST_HD_REDIRECT: 'HDRedirect',
        REQUEST_HD_REDIRECT_COMPLETE: 'HDRedirectComplete',
        REQUEST_ENTER_FLOW: 'EnterRequestFlow',
        HOMEPAGE_MODAL: 'HomepageModal',
        HOMEPAGE_SEARCH: 'Search',
        PAGE_LOAD: 'PageLoad',
        CONSUMER_REQUEST_SERVICE: 'ConsumerRequestService',
        CONSUMER_HIRED_FEEDBACK: 'ConsumerHiredFeedback',
        CONSUMER_NOT_HIRED_FEEDBACK: 'ConsumerNotHiredFeedback',
        CONSUMER_VIEWED_PRO_CARD: 'ConsumerViewedProCard',
        CONSUMER_CANCEL_REQUEST: 'CostumerCancelRequest',
        PRO_JOB_SEARCH: 'JobSearch',
        PRO_PHOTO_VIEWED: 'ViewPhoto',
        PRO_JOB_REJECT: 'JobPass',
        PRO_BUSY_JOB_REJECT: 'BusyJobPass',
        PRO_JOB_ACCEPT: 'JobFollowUp',
        PRO_JOB_REACTIVATE: 'JobReactivate',
        PRO_CALL: 'Call',
        PRO_SEND_MESSAGE: 'SendMessage',
        PRO_SEND_MESSAGE_ERROR: 'SendMessageError',
        PRO_CHANGE_STATUS: 'ChangeJobStatus',
        PRO_CHANGE_STATUS_ERROR: 'ChangeJobStatusError',
        PRO_VACATION_CHANGE: 'VacationMode',
        PRO_SIGNUP: 'ProSignUp',
        SAVE_NOTES: 'SaveNotes',
        USER_IDENTIFY: 'Identify',
        USER_CREATION: 'UserCreation',
        USER_LOGIN: 'UserLogin',
        INCREMENT: 'Increment',
        MODAL_CLICK: 'ModalClick',
        CAROUSEL_CLICK: 'CarouselClick',
        REVIEWS_CLICK: 'ReviewsClick',
        REVIEWS_ERROR: 'ReviewsError',
        REVIEWS_RETRY: 'ReviewsRetry',
        LEAD_SUBMIT: 'LeadSubmit',
        LEAD_FAILURE: 'LeadFailure',
        LEAD_SUCCESS: 'LeadSuccess',
        PRO_WARNING: 'ProWarning',
        PRO_PERM_ERROR: 'ProPermError',
        FAQ_VIEWED: 'FAQViewed',
        FAQ_PHONE_LINK_CLICKED: 'FAQPhoneLinkClicked',
        FAQ_EMAIL_LINK_CLICKED: 'FAQEmailLinkClicked',
        APPOINTMENT_CREATED: 'AppointmentCreated',
        APPOINTMENT_DELETED: 'AppointmentDeleted',
        URL_CLICK: 'UrlClick',
        HISTORY_APPLY_FILTER_CLICK: 'HistoryApplyFilterClick',
        VIEW_HISTORY_FROM_SUMMARY: 'ViewHistoryFromSummary',
        PERFORMANCE_RESPONSE_CLICK: 'PerformanceResponseClick',
        PERFORMANCE_ACCEPTANCE_CLICK: 'PerformanceAcceptanceClick',
        PERFORMANCE_COMPLETED_CLICK: 'PerformanceCompletedClick',
        PERFORMANCE_HISTORY_MODAL_CLICK: 'PerformanceHistoryModalClick',
        TESTIMONIAL_CONTENT_ERROR: 'TestimonialContentError',
        TESTIMONIAL_ERROR: 'TestimonialError',
        PRO_PAUSE_CREATION: 'ProPauseCreation',
        PRO_PAUSE_UPDATE: 'ProPauseUpdate',
        PRO_PAUSE_DELETE: 'ProPauseDelete',
        PRO_PAUSE_CREATION_ERROR: 'ProPauseCreationError',
        PRO_PAUSE_UPDATE_ERROR: 'ProPauseUpdateError',
        PRO_PAUSE_DELETE_ERROR: 'ProPauseDeleteError',
        LOGIN_TAB_SWITCH: 'LoginTabSwitch',
        OTC_REQUEST_CLICK: 'RequestOTCClicked',
        OTC_REQUEST_CLICK_ERROR: 'RequestOTCClickedError',
        OTC_ENTER_CLICK: 'LoginOTCClicked',
        OTC_ENTER_CLICK_ERROR: 'LoginOTCClickedError',
        OTC_SEND_ANOTHER_CODE_CLICK: 'SendAnotherCodeOTCClicked',
        SAVE_PASSWORD_CLICK: 'SavePasswordClick',
        DO_NOT_WANT_TO_CREATE_PASSWORD_CLICK: 'DoNotWantToCreatePasswordClick',
        OTC_LOGIN_PAGE_CLICK: 'OTCFromLoginPageClick',
        TRENDING_SERVICES_ZIP_SEARCH: 'TrendingServicesZipSearch',
        TRENDING_SERVICES_CLICK: 'TrendingServicesClick',
        INVITE_URL_CLICKED: 'InviteUrlClicked',
        INVITE_SHARE_CLICKED: 'InviteShareClicked',
        NOTIFICATIONS_TAB_CHANGE: 'NotificationsTabChange',
        WHATS_NEW_SEARCH: 'WhatsNewSearch',
        WHATS_NEW_BUTTON_CLICK: 'WhatsNewButtonClick',
        SUB_STATUS_UPDATE: 'SubStatusUpdate',
        SUB_STATUS_INITIAL: 'SubStatusInitial',
        SUB_STATUS_FILTER: 'SubStatusFilter',
        TOOL_RENTAL_CLICK: 'ToolRentalClick',
        RESOURCE_OPEN_PDF: 'ResourceOpenPdf',
        OTHER_CONTACT_STATUS: 'OtherContactStatus',
        APPOINTMENT_DOTS_DELETE_CLICK: 'AppointmentDotsDeleteClick',
        APPOINTMENT_DOTS_EDIT_CLICK: 'AppointmentDotsEditClick',
        APPOINTMENT_DOTS_EXPORT_CLICK: 'AppointmentDotsExportClick',
        PAUSE_DOTS_DELETE_CLICK: 'PauseDotsDeleteClick',
        PAUSE_DOTS_EDIT_CLICK: 'PauseDotsEditClick',
        B2B_URL_CLICK: 'B2BUrlClick',
        USER_LOGIN_FAILURE: 'UserLoginFailure',
        THUMB_CLICK: 'ThumbClick',
        SURVEY_CLICK: 'SurveyClick',
        PRO_SHOPPING_CLICK: 'ProShoppingClick',
        VIDEO_RATING: 'VideoRating',
        OPEN_QUIZ: 'OpenQuiz',
        REWATCH_FROM_VIDEO: 'RewatchFromVideo',
        WHAT_IS_THIS_CLICK: 'WhatIsThisClicked',
        REWATCH_FROM_QUIZ: 'RewatchFromQuiz',
        RETURN_EDUCATION_HOME: 'ReturnEducationHome',
        WATCH_VIDEO: 'WatchVideo',
        VIDEO_SEARCH: 'VideoSearch',
        VIDEO_CATEGORY_CLICK: 'VideoCategoryClick',
        VIDEO_MY_PROGRESS_CLICK: 'VideoMyProgressClick',
        QUIZ_MODAL_BUTTON: 'QuizModalButton',
        QUIZ_SUBMIT: 'QuizSubmit',
        QUIZ_FAILED: 'QuizFailed',
        WATCH_NEXT_VIDEO: 'WatchNextVideo',
        OCCUPATION_EDIT: 'OccupationEdit',
        POINTS_FILTER_APPLY_CLICK: 'PointsFilterApplyClick',
        POINTS_FILTER_CLICK: 'PointsFilterClick',
        ERROR_PAGE_LOAD: 'ErrorPageLoad',
        POSSIBLE_AD_BLOCKER: 'PossibleAdBlocker',
        LIMIT_MODAL_OPEN: 'LimitModalOpen',
      };
    },
  });
}
